import React, { useCallback } from 'react';
import { Space, Typography, Divider } from 'antd';
import Button from '@mui/material/Button';
import {stringMixin} from "../../utils/strings";
import { Card, Stack, CardHeader } from '@mui/material';
import PnL from "../../components/PnL";

const ItemNode = ({name, value})=>{
  return (
      <Space direction={'vertical'}>
          <Typography.Text strong style={{fontSize: '11px', textTransform: 'uppercase', fontWeight: '700', color: "#000"}}>
              {name}
          </Typography.Text>
            <PnL value={value}/>
      </Space>
  )
}

const ChangesBar = ({ percentageReturns, onSnapToValue }) => {
    console.log(percentageReturns);



  return (

            <Card
                style={{
                    backgroundColor: '#f5f5f5',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                    zIndex: 9999, // Ensure it's above everything else
                    position: 'fixed', // Fix position to the top
                    top: 100, // Stick to the top
                    left: '35%'
                }}
            >
                <Space>
                    {percentageReturns.map((returnItem, index) => (
                        <>
                            <div onClick={()=>onSnapToValue(returnItem.seriesName)}>
                            <ItemNode key={index}
                                      name={returnItem.seriesName}
                                      value={returnItem.percentageReturn}

                            />
                                </div>
                            <Divider type={'vertical'} />
                        </>
                    ))}
                </Space>
          </Card>

  );
};

export default ChangesBar;
